import React from 'react'
import { FormControl } from 'baseui/form-control'
import SDSelect from '@/shared/components/SDComponentsNewDesign/SDSelect/SDSelect'
import SDButtonGroupBase from '@/shared/components/SDComponentsNewDesign/SDButtonGroup/SDButtonGroup'
import SDFormControl from '@/shared/components/SDComponentsNewDesign/SDFormControl/SDFormControl'

const SDButtonGroup = SDButtonGroupBase as React.ComponentType<any>

const BUTTON_GROUP_THRESHOLD = 3

export type SDAdaptiveOption = {
  id: string
  label: string
}

type SDAdaptiveOptionsProps = {
  options: SDAdaptiveOption[]
  selectedValue: string
  onChangeHandler: (id: string) => void
  label?: string
  placeholder?: string
  disabled?: boolean
  error?: string
}

const SDAdaptiveOptions = ({
  options,
  selectedValue,
  onChangeHandler,
  label,
  placeholder = '',
  disabled = false,
  error,
}: SDAdaptiveOptionsProps) => {
  if (options.length > BUTTON_GROUP_THRESHOLD) {
    const optionsList = Object.fromEntries(options.map(opt => [opt.id, opt.label]))
    return (
      <SDFormControl>
        {/* @ts-ignore */}
        <SDSelect
          label={label}
          optionsList={optionsList}
          selectedValue={selectedValue}
          onChangeHandler={(params: any) => onChangeHandler(params.value[0]?.id ?? '')}
          placeholder={placeholder}
          disabled={disabled}
          hasError={!!error}
        />
      </SDFormControl>
    )
  }

  const buttonGroupOptions = options.map(opt => ({ [opt.id]: opt.label }))
  return (
    <FormControl
      label={label ? () => <span dangerouslySetInnerHTML={{ __html: label }} /> : undefined}
      error={error}
    >
      <SDButtonGroup
        options={buttonGroupOptions}
        selectedValue={selectedValue}
        onClickHandler={onChangeHandler}
        disabled={disabled}
        error={error}
      />
    </FormControl>
  )
}

export default SDAdaptiveOptions
